import { Box, Modal,useTheme,Button, IconButton,Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import DeleteIcon from '@mui/icons-material/Delete';
import ColumnForm from "./addColumnsForm";
import EditIcon from '@mui/icons-material/Edit'
import Header from "../../components/Header";
import AuthGuard from "../../components/AuthGuard";
import Form from "./form";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import IosShareIcon from '@mui/icons-material/IosShare';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import Tooltip from '@mui/material/Tooltip';
import swal from "sweetalert";

const Company = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [showModal,setShowModal] = useState(false)
  const [showModalColumnsCompany,setShowModalColumnsCompany] = useState(-1)
  const [formData,setFormData] = useState(null)
  const [companiesData,setCompaniesData] = useState([])
  const [cookies,setCookie] = useCookies(['token'])

  const fetchCompanies = async()=>{
    const data = await fetch(process.env.REACT_APP_BACKEND_URL+"/company/all",{headers:{
      Authorization:"Bearer "+cookies['token']
    }})
    if(data.status!==200){
      setCookie("token",null)
      return
    }
    const json = await data.json()
    setCompaniesData(()=>{
      return json.map((usr,ind)=>({...usr,no:ind+1}))
    })
  }

  useEffect(()=>{
    fetchCompanies()
  },[])

  const callbackAfterSubmit = ()=>{
    fetchCompanies().then(()=>{
      setShowModal(false)
    })
  }

  const callbackAfterSubmitCompanyForm = ()=>{
    setShowModalColumnsCompany(-1)
  }

  const editUser = (row)=>{
    setShowModal(true)
    setFormData(row)
  }

  const deleteUser = (id)=>{
    const resp = window.confirm("Are You Sure?")
    if(resp){
      fetch(process.env.REACT_APP_BACKEND_URL+"/company/delete/"+id,{method:"DELETE",headers:{
        Authorization:"Bearer "+cookies['token']
      }}).then(()=>{
        setCompaniesData((prev)=>{
          return prev.filter(dt=>dt.id!==id)
        })
      }).catch(()=>{
        setCookie("token",null)
      })
    }
  }

  const toggleEnableStatus = async (companyId, currentStatus) => {
    let confirmationMessage;
    switch (currentStatus) {
        case true:
            confirmationMessage = "Are you sure you want to disable?";
            break;
        case false:
            confirmationMessage = "Are you sure you want to enable?";
            break;
        default:
            confirmationMessage = "Are you sure you want to switch status?";
    }
    const confirmed = window.confirm(confirmationMessage);    if (!confirmed) return;
  
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/company/${companyId}/toggleEnable`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + cookies['token']
        },
        body: JSON.stringify({ enable: !currentStatus }) 
      });
  
      const responseData = await response.json();
  
      if (response.ok) {
        swal("Success", responseData.message, "success");
        window.location.reload();
      } else {
        if (response.status === 401) {
          setCookie("token", null);
          swal("Failed", responseData.message, "error");
        } else if (response.status === 404) {
          swal("Failed", responseData.message, "error");

        } else {
          
          throw new Error(responseData.message);
          swal("Failed", responseData.message, "error");
        }
      }
    } catch (error) {
      console.error('Error toggling user enable status:', error);
      swal("Failed", "Error toggling user enable status. Please try again", "error");
    }
  }
  const columns = [
    { field: "no", headerName: "No" },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "code",
      headerName: "Code",
      flex: 1,
    },
    {
        field: "_enabled",
        headerName: "Status",
        flex: 1,
        renderCell: ({ row }) => {
          const iconColor = row._enabled ? "green" : "red";
          const transactionType = row._enabled ? "Enabled" : "Disabled";
          const icon = { transactionType, style: { color: iconColor } };
          return (
            <Typography color={colors.black[500]} sx={{ ml: "5px" }}>
              <span style={{ color: iconColor }}>{icon.transactionType}</span>
            </Typography>
          );
        }
    },
    {
      field: "Action",
      headerName: "Action",
      flex: 1,
      renderCell: ({ row }) => {
        const iconColor = row._enabled ? "green" : "red";
        const icon = row._enabled ?  (
          <Tooltip title="Enable Company" arrow>
            <ToggleOnIcon style={{ color: iconColor, fontSize: '40px' }} />
          </Tooltip>
        ): (
          <Tooltip title="Disable Company" arrow>
            <ToggleOffIcon style={{ color: iconColor, fontSize: '40px'}} />
          </Tooltip>
        );
        return (
          <Box>
             <IconButton onClick={() => toggleEnableStatus(row.id, row._enabled)}>
              <Typography color={colors.black[500]} sx={{ ml: "5px", mt:"10px"}}>
        {icon}
      </Typography>
            </IconButton>
              <IconButton onClick={()=>editUser(row)}>
                  <EditIcon style={{color:"#2196f3"}}/>
              </IconButton>
              <IconButton onClick={()=>deleteUser(row.id)}>
                    <DeleteIcon style={{color:"red"}}/>
              </IconButton>
              <IconButton variant="contained" onClick={()=>setShowModalColumnsCompany(row.id)}>
                <IosShareIcon style={{color:"#008083"}}/>
              </IconButton>
          </Box>
        );
      },
    }
  ];

  return (
    <AuthGuard>
    <Box m="10px">
    <Modal open={showModal} onClose={()=>setShowModal(false)}>
      <Form callBackAfterSubmit={callbackAfterSubmit} formData={formData}/>
    </Modal>
    <Modal open={showModalColumnsCompany!==-1} onClose={()=>setShowModalColumnsCompany(-1)}>
      <ColumnForm callBackAfterSubmit={callbackAfterSubmitCompanyForm} companyId={showModalColumnsCompany}/>
    </Modal>
    <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
      <Header subtitle="Managing Companies" />
      <Button variant="contained" sx={{height:"2rem",width:"10rem",boxSizing:"border-box",background:"#1A8D90",color:"#fff"}} onClick={()=>setShowModal(true)}>
                Add Company
      </Button>
      </Box>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          '& .MuiDataGrid-row:nth-child(odd)': {
            border: "1px solid white",
            backgroundColor: theme.palette.mode === 'light' ? colors.white[300] : "#F3F5F8",
          },
          '& .MuiDataGrid-iconSeparator': {
            display: 'none',
          },
          "& .MuiDataGrid-root": {
            border: "1px solid white !important",
          },
          
          "& .MuiDataGrid-row": {
            border: "1px solid white !important",
          },
          "& .MuiDataGrid-row--lastVisible": {
            borderBottom: "1px solid white !important",
          },
          "& .MuiDataGrid-cell": {
            fontSize: 15,
            color: colors.black[500],
            border: "none !important",

          },
          "& .name-column--cell": {
            fontWeight: "bold",
            color: colors.black[500],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.white[500],
            color: colors.black[900],
            fontSize: 20,
            border: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            lineHeight: "normal",
            fontWeight: "bold",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[500],
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: colors.white[500],
            border: "none",

          },
          "& .MuiDataGrid-pagination": {
            "& .MuiTablePagination-menuItem": {
              color: "#000000",
            },
          },
          "& .MuiTablePagination-root": {
            color: "#000000",
          },
          "& .MuiSvgIcon-root ": {
            color: "#000000",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            left: "75%", /* Position the element at the center horizontally */
            transform: `translateX(-75%)`,
            color: `${colors.black[500]} !important`,
          },
          "& .MuiCheckbox-root": {
            color: `${colors.black[500]} !important`,
          },
            "& .MuiDataGrid-row:hover": {
            backgroundColor: "none",
            },
        }}
      >
        <DataGrid rows={companiesData} columns={columns} />
      </Box>
    </Box>
    </AuthGuard>
  );
};

export default Company;
